import callApi from 'helpers/callApi';

export const getCategories = (params) => callApi({ url: '/categories', query: params });
export const getCategory = (slug) => callApi({ url: `/categories/${slug}` });
export const getSubCategory = (categorySlug, subCategorySlug) => callApi({ url: `/categories/${categorySlug}/subcategories/${subCategorySlug}` });

export const deleteCategory = (id) => callApi({ url: `/categories/${id}`, method: 'delete' });
export const deleteSubcategory = (id) => callApi({ url: `/subcategories/${id}`, method: 'delete' });

export const createNewSubCategory = (data) => callApi({ url: `/categories/${data.parent}/subcategories`, body: data });

export const upsertCategory = (data) => callApi({ url: `/categories/${data._id ? data._id : ''}`, body: data });
export const updateSubCategory = (data) => callApi({ url: `/subcategories/${data._id}`, body: data, method: 'put' });
